// Chatwoot dashboard already has Tailwind preflight; skip global Normalize (standalone Dev-Phone HTML still loads it).
const REMOTE_STYLE_URLS = [
  'https://dtd6jl0d42sve.cloudfront.net/lib/fonts/font_roboto/roboto.css',
  'https://dtd6jl0d42sve.cloudfront.net/lib/fonts/font_awesome/css/font-awesome.min.css',
  'https://dtd6jl0d42sve.cloudfront.net/lib/jquery/jquery-ui-1.13.2.min.css',
  'https://dtd6jl0d42sve.cloudfront.net/lib/Croppie/Croppie-2.6.4/croppie.css',
];

const REMOTE_SCRIPT_URLS = [
  'https://dtd6jl0d42sve.cloudfront.net/lib/jquery/jquery-3.6.1.min.js',
  'https://dtd6jl0d42sve.cloudfront.net/lib/jquery/jquery-ui-1.13.2.min.js',
  'https://dtd6jl0d42sve.cloudfront.net/lib/jquery/jquery.md5-min.js',
  'https://dtd6jl0d42sve.cloudfront.net/lib/Chart/Chart.bundle-2.7.2.min.js',
  'https://dtd6jl0d42sve.cloudfront.net/lib/FabricJS/fabric-2.4.6.min.js',
  'https://dtd6jl0d42sve.cloudfront.net/lib/Moment/moment-with-locales-2.24.0.min.js',
  'https://dtd6jl0d42sve.cloudfront.net/lib/Croppie/Croppie-2.6.4/croppie.min.js',
  'https://dtd6jl0d42sve.cloudfront.net/lib/XMPP/strophe-1.4.1.umd.min.js',
];

export const getBrowserPhoneStyleUrls = hostingPrefix => [
  ...REMOTE_STYLE_URLS,
  `${hostingPrefix}phone.embed.css`,
  `${hostingPrefix}style.embed.css`,
];

export const getBrowserPhoneScriptUrls = hostingPrefix => [
  ...REMOTE_SCRIPT_URLS,
  // SIP.js 0.21 does not attach a window `unload` listener (blocked by Chrome 146+).
  `${hostingPrefix}sip-0.21.2.min.js`,
];

export const getBrowserPhoneRuntimeUrl = hostingPrefix =>
  `${hostingPrefix}phone.js`;

export const buildBrowserPhoneOptions = bootstrap => ({
  loadAlternateLang: bootstrap.load_alternate_lang,
  wssServer: bootstrap.wss_server,
  WebSocketPort: bootstrap.web_socket_port,
  ServerPath: bootstrap.server_path,
  SipDomain: bootstrap.sip_domain,
  profileName: bootstrap.display_name || bootstrap.name,
  userAgentStr: bootstrap.user_agent_string,
  ChatEngine: bootstrap.chat_engine,
  SipUsername: bootstrap.sip_username,
  SipPassword: bootstrap.sip_password,
  TransportConnectionTimeout: bootstrap.transport_connection_timeout,
  TransportReconnectionAttempts: bootstrap.transport_reconnection_attempts,
  TransportReconnectionTimeout: bootstrap.transport_reconnection_timeout,
  WssInTransport: bootstrap.wss_in_transport,
  IpInContact: bootstrap.ip_in_contact,
  IceStunServerJson: bootstrap.ice_stun_server_json,
  BundlePolicy: bootstrap.bundle_policy,
  hostingPrefix: bootstrap.hosting_prefix,
});
